/**
 * @file: 中国直发商品
 * 输出系统自带提示
 * IconChinaOrderTips 与 IconDirectPo 略有差别
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/10/09      1.0     First version
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */
import React from 'react';
const IconChinaOrderGoods = ({size=24,className="", title= ""}) => {
    return (<img className="iconfont" width={size} className={className} title={title}
             src={"https://oss.essaone.com/c3ba5609-8ada-4edc-8a4f-e08eee0becc1.svg"}></img>
    );
}

export default IconChinaOrderGoods;
